import React from "react";
import { DELIVERY_STATUS_COLORS } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function StatusBadge({ status, className }) {
  const color = DELIVERY_STATUS_COLORS[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={cn("inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold", color, className)}
    >
      {status}
    </span>
  );
}
